<template>
  <v-dialog
    v-model="show"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <v-card>
      <v-toolbar dark color="secondary">
        <v-toolbar-title>
          <v-btn icon small @click="show = false">
            <v-icon small>mdi-chevron-left</v-icon>
          </v-btn>
          {{ $vuetify.lang.t('$vuetify.EDIT_FLEETS.FLEET_USERS') }} -
          {{ fleet.Name }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon small @click="show = false">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-data-table
          :items="fleet.Users ? fleet.Users : []"
          :loading="
            loading.type === 'getFleet' || loading.type === 'getFleetUsers'
          "
          :headers="[
            {
              text: 'Phone nr',
              align: 'start',
              sortable: false,
              value: 'PhoneNumber'
            },
            { text: 'Licence plate', sortable: false, value: 'CarNumber' },
            { text: 'Name', sortable: true, value: 'Name' },
            { text: 'Email', sortable: true, value: 'Email' },
            { text: 'Daily limit', sortable: true, value: 'DailyLimitInCents' },
            {
              text: 'Monthly limit',
              sortable: true,
              value: 'MonthlyLimitInCents'
            },
            { text: 'Reg. type', sortable: true, value: 'RegistrationType' },
            { text: 'Reg. time', sortable: true, value: 'CreatedAt' },
            { text: 'Status', value: 'Status' },
            { text: '', sortable: false, value: 'actions' }
          ]"
          :items-per-page="-1"
          hide-default-footer
        >
          <template v-slot:top>
            <v-toolbar flat class="mt-4">
              <v-spacer></v-spacer>
              <vue-xlsx-table @on-select-file="onFileSelect">
                <v-btn small text color="dark">
                  <v-icon class="mr-2">mdi-file-import</v-icon>
                  {{ $vuetify.lang.t('$vuetify.IMPORT_FROM_FILE') }}
                </v-btn>
              </vue-xlsx-table>
              <v-btn
                color="success"
                text
                small
                @click="openEditFleetUserDialog()"
              >
                <v-icon class="mr-2">mdi-plus</v-icon>
                {{ $vuetify.lang.t('$vuetify.WHITELISTS.ADD_NEW') }}
              </v-btn>
            </v-toolbar>
          </template>
          <template v-slot:item.PhoneNumber="props">
            <td>
              {{ props.item.PhoneNumber ? props.item.PhoneNumber : '-' }}
            </td>
          </template>
          <template v-slot:item.Name="props">
            <td>
              {{ props.item.Name ? props.item.Name : '-' }}
            </td>
          </template>
          <template v-slot:item.CarNumber="props">
            <td>
              {{ props.item.CarNumber.length ? props.item.CarNumber : '-' }}
            </td>
          </template>
          <template v-slot:item.Email="props">
            <td>
              {{ props.item.Email ? props.item.Email : '-' }}
            </td>
          </template>
          <template v-slot:item.DailyLimitInCents="props">
            <td>
              {{ props.item.DailyLimitInCents / 100 }} {{ fleet.Currency }}
            </td>
          </template>
          <template v-slot:item.MonthlyLimitInCents="props">
            <td>
              {{ props.item.MonthlyLimitInCents / 100 }}
              {{ fleet.Currency }}
            </td>
          </template>
          <template v-slot:item.RegistrationType="{ item }">
            <td>
              {{ registrationTypeText(item.RegistrationType) }}
            </td>
          </template>
          <template v-slot:item.CreatedAt="props">
            <td>{{ dateEE(props.item.CreatedAt) }}</td>
          </template>
          <template v-slot:item.Status="props">
            <td>
              <span
                v-if="props.item.Status === 'APPROVED'"
                class="success--text"
              >
                {{ props.item.Status }}
              </span>
              <span v-else>{{ props.item.Status }}</span>
            </td>
          </template>
          <template v-slot:item.Status="props">
            <td>
              <span
                v-if="props.item.Status === 'APPROVED'"
                class="success--text"
              >
                {{ props.item.Status }}
              </span>
              <span v-else>{{ props.item.Status }}</span>
              <div
                v-if="props.item.Status == '' || props.item.Status == 'PENDING'"
              >
                <v-btn
                  color="success"
                  outlined
                  small
                  class="mr-1"
                  @click="updateUserStatus(props.item, 'APPROVED')"
                >
                  Approve
                </v-btn>
                <v-btn
                  v-show="props.item.RegistrationType !== 'MANUALLY_ADDED'"
                  color="error"
                  outlined
                  small
                  @click="updateUserStatus(props.item, 'DECLINED')"
                >
                  Decline
                </v-btn>
              </div>
            </td>
          </template>
          <template v-slot:item.actions="{ item }">
            <td>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    icon
                    color="primary"
                    small
                    outlined
                    class="mr-3"
                    @click="openEditFleetUserDialog(item)"
                    v-on="on"
                  >
                    <v-icon small>mdi-pencil</v-icon>
                  </v-btn>
                </template>
                <span>
                  {{ $vuetify.lang.t('$vuetify.EDIT') }}
                </span>
              </v-tooltip>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    icon
                    color="error"
                    small
                    outlined
                    @click="deleteUser(item)"
                    v-on="on"
                  >
                    <v-icon small>mdi-delete</v-icon>
                  </v-btn>
                </template>
                <span>
                  {{ $vuetify.lang.t('$vuetify.DELETE') }}
                </span>
              </v-tooltip>
            </td>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <edit-fleet-user-dialog
      v-if="selectedUser"
      :selected-user="selectedUser"
      :visible="editFleetUserDialog"
      @close="
        editFleetUserDialog = false
        selectedUser = null
      "
    />
    <v-dialog v-model="userImportConfirmDialog" width="700">
      <v-card>
        <v-card-title class="headline lighten-2" primary-title>
          {{ $vuetify.lang.t('$vuetify.PREVIEW') }}
          <v-spacer></v-spacer>
          <v-btn icon small @click="userImportConfirmDialog = false">
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">
                    {{
                      $vuetify.lang.t('$vuetify.EDIT_WHITELISTS.PHONE_NUMBER')
                    }}
                  </th>
                  <th class="text-left">
                    {{ $vuetify.lang.t('$vuetify.EDIT_WHITELISTS.CAR_NUMBER') }}
                  </th>
                  <th class="text-left">
                    {{ $vuetify.lang.t('$vuetify.EDIT_WHITELISTS.NAME') }}
                  </th>
                  <th class="text-left">
                    {{ $vuetify.lang.t('$vuetify.EDIT_WHITELISTS.EMAIL') }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in arrayOfMappedImportedUsers" :key="item.name">
                  <td>{{ item.PhoneNumber }}</td>
                  <td>
                    {{
                      item.Vehicles && item.Vehicles.length
                        ? Object.keys(item.Vehicles)
                            .map(function(i) {
                              return item.Vehicles[i].PlateNumber
                            })
                            .join(';')
                        : '-'
                    }}
                  </td>
                  <td>{{ item.Name }}</td>
                  <td>{{ item.Email }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="secondary--text"
            text
            @click="postUsers()"
          >
            {{ $vuetify.lang.t('$vuetify.SAVE') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import formatDate from '@/mixins/formatDate'
import Fleet from '@/models/fleet'
import FleetUser from '@/models/fleet-user'

export default {
  name: 'FleetUsers',
  components: {
    EditFleetUserDialog: () =>
      import(
        /* webpackChunkName: "EditFleetUserDialog" */ '@/components/fleets/EditFleetUserDialog'
      )
  },
  mixins: [formatDate],
  props: {
    visible: {
      type: Boolean,
      required: true,
      default: false
    },
    title: {
      type: String,
      required: false,
      default: ''
    }
  },
  data() {
    return {
      editFleetUserDialog: false,
      selectedUser: null,
      userImportConfirmDialog: false,
      arrayOfMappedImportedUsers: []
    }
  },
  computed: {
    ...mapGetters('app', ['loading']),
    ...mapGetters('fleets', ['fleet']),
    show: {
      get() {
        return this.visible
      },
      set(value) {
        if (!value) {
          this.$store.commit('fleets/setCurrentFleetId', null)
          this.$store.commit('fleets/setFleet', new Fleet().getObject())
          this.$emit('close')
        }
      }
    }
  },
  methods: {
    ...mapActions('fleets', ['updateAndSaveFleetUserStatus']),
    openEditFleetUserDialog(user) {
      if (user) {
        this.selectedUser = user
      } else {
        this.selectedUser = new FleetUser().getObject()
      }
      this.editFleetUserDialog = true
    },
    registrationTypeText(registrationType) {
      switch (registrationType) {
        case 'MANUALLY_ADDED':
          return 'Manual'
        case 'LINK_REGISTRATION':
          return 'Public Link'
        case 'CAMPAIGN_CODE':
          return 'Campaign Code'
        case 'ONE_TIME_PROMO_CODE':
          return 'One-time promo code'
        default:
          return 'Other'
      }
    },
    deleteUser(user) {
      this.$confirm(this.$vuetify.lang.t('$vuetify.CAN_NOT_BE_UNDONE'), {
        title: this.$vuetify.lang.t('$vuetify.ARE_YOU_SURE'),
        color: 'error',
        icon: 'mdi-alert',
        persistent: true,
        buttonTrueText: this.$vuetify.lang.t('$vuetify.YES'),
        buttonFalseText: this.$vuetify.lang.t('$vuetify.CANCEL')
      }).then(option => {
        if (option === true) {
          this.$store.dispatch('fleets/deleteFleetUser', user)
        }
      })
    },
    uploadImportedFile(files) {
      const arrayOfMappedUsers = []
      files.body.forEach(user => {
        arrayOfMappedUsers.push({
          Name: user.Name,
          Email: user.Email,
          PhoneNumber: user['Phone number'],
          CarNumber: user['Car number'],
          RegistrationType: 'MANUALLY_INVITED'
        })
        this.$store.dispatch('fleets/postFleetUsers', arrayOfMappedUsers)
      })
    },
    onFileSelect(files) {
      this.userImportConfirmDialog = true
      if (this.arrayOfMappedImportedUsers.length) {
        this.arrayOfMappedImportedUsers = []
      }
      files.body.forEach(user => {
        this.arrayOfMappedImportedUsers.push({
          Name: user.Name,
          Email: user.Email,
          PhoneNumber: user['Phone number'],
          Vehicles: [{ PlateNumber: user['Car number'] }],
          RegistrationType: 'MANUALLY_ADDED'
        })
      })
    },
    postUsers() {
      this.$store.dispatch(
        'fleets/postFleetUsers',
        this.arrayOfMappedImportedUsers
      )
      this.userImportConfirmDialog = false
    },
    updateUserStatus(fleetUser, status) {
      this.updateAndSaveFleetUserStatus({
        fleetUserId: fleetUser.ID,
        status
      })
    }
  }
}
</script>

<style scoped>
::v-deep .vue-xlsx-container .xlsx-button {
  background-color: transparent;
  border: none;
}
</style>
